import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-badge-renderer',
  template: `
    <ng-container *ngIf="isStatusField; else defaultBadge">
      <span class="status-wrapper" [ngClass]="badgeClass">
        <span class="status-dot" [ngClass]="dotClass"></span>
        {{ value }}
      </span>
    </ng-container>

    <ng-template #defaultBadge>
      <span class="badge" [ngClass]="badgeClass">{{ value }}</span>
    </ng-template>
  `,
  styleUrls: ['./badge-renderer.component.scss'],
})
export class BadgeRendererComponent implements ICellRendererAngularComp {
  value: string = '';
  badgeClass: string = 'badge-default';
  dotClass: string = '';
  isStatusField: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.value = params.value?.trim();
    const field = params?.colDef?.field?.toLowerCase?.();

    this.isStatusField = field === 'status';

    if (this.isStatusField && this.value) {
      const slug = this.value.toLowerCase().replace(/\s+/g, '-');
      this.badgeClass = `badge-status-${slug}`;
      this.dotClass = `badge-status-${slug}-dot`;
    } else {
      this.badgeClass = `badge-${this.value?.toLowerCase?.() || 'default'}`;
    }
  }

  refresh(): boolean {
    return true;
  }
}
